// extracted by mini-css-extract-plugin
export default {"menuIcon":"DotMenu_menuIcon__g4xQl","dotMenu":"DotMenu_dotMenu__v2B5K","dotMenuRtl":"DotMenu_dotMenuRtl__3S-0p"};